<template>
<div>
    <div id="cogene" class="wrapper">
        <!-- 内容は以下に記述して下さい。 -->
        <!-- コージェネ -->
        <app-error-list/>
        <app-section id="cogeneration">
            <h3 slot="h3">
                <parts-arrow category="コージェネ">1</parts-arrow>
                <span>コージェネレーション設備の設置の有無等を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="コージェネレーション設備"
                class="flex_column"
                name="use_cogen"
                @click="guideTransition"
            >
                <div v-for="(name, value) in master.use_cogen" 
                        :key="use_cogen + value">
                    <app-radio
                        v-model="use_cogen"
                        :value="value"
                        unit=""
                    >
                        {{name}}
                    </app-radio>
                </div>
                <information-box title="太陽光発電設備とコージェネレーション設備とを同時に設置する場合">
                    <p>太陽光発電設備は、太陽光タブにおいて<a href="https://house.lowenergy.jp/dictionary/solar" target="guide" class="target_blank">こちら</a>を参考に入力します。<br/>
                    コージェネレーション設備は、コージェネタブにおいて<a href="https://house.lowenergy.jp/dictionary/cogene" target="guide" class="target_blank">こちら</a>を参考に入力します。</p>
                </information-box>
            </app-box>
        </app-section>



        
        <!-- コージェネ機器を設置する場合 -->
        <app-section v-if="use_cogen == '2'">
            <h3 slot="h3">
                <parts-arrow category="コージェネ">2</parts-arrow>
                <span><parts-arrow class="line">1</parts-arrow>でコージェネレーション機器を「設置する」を選択した場合、コージェネレーション設備の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="コージェネレーション機器の指定"
                class="flex_column"
                name="cogen_package_input"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','3','1']"
                    v-model="cogen_package_input"
                    :value="value"
                    unit=""
                    :key="'cogen_package_input' + value"
                    :class="{el_radio__pale : value == '3'}"
                >
                    {{master.cogen_package_input[value]}}
                </app-radio>
                <information-box
                    title="品番を指定しない場合"
                >
                    品番を指定せずに計算した結果を公的な届出や補助金の申請に利用する場合は、「品番を指定しない（規定値を用いる）」を選択します。
                </information-box>
            </app-box>
            <app-box
                :available="true"
                label="コージェネレーションの種類"
                class="flex_column"
                name="cogen_type"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.cogen_type"
                    v-model="cogen_type"
                    :value="value"
                    unit=""
                    :key="'cogen_type' + value"
                    v-show="cogen_package_input == '2' ||(cogen_package_input !== '2' && value !== '4') "
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                v-if="cogen_package_input != 2"
                :available="true"
                label="逆潮流の評価"
                class="flex_column"
                name="cogen_reverse"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.cogen_reverse"
                    v-model="cogen_reverse"
                    :value="value"
                    unit=""
                    :key="'cogen_reverse' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>

            <div v-if="cogen_type != 4 && cogen_package_input == 1">
                <app-box
                    :available="true"
                    label="品番"
                    class="flex_column"
                    name="search_cogen_text"
                    @click="guideTransition"
                >
                    <!--  PEFCの場合  -->
                    <search-button
                        v-if="cogen_type == 1"
                        v-model="cogen_pefc_package_filter"
                        id="cogen_pefc_filter"
                        label="メーカ名、品番等の一部"
                        placeholder=""
                        button-name="検索"
                        class="str15em align_left"
                        @click="searchPefcCogenItem"
                    />
                    <selected-cogen-table
                        v-if="isPefcSelected" 
                        :selected-data="getSelectedPefc"
                    />
                    <!--  SOFCの場合 -->
                    <search-button 
                        v-if="cogen_type == 2"
                        v-model="cogen_sofc_package_filter"
                        id="cogen_sofc_filter"
                        label="メーカ名、品番等の一部"
                        placeholder=""
                        button-name="検索"
                        class="str15em align_left"
                        @click="searchSofcCogenItem"
                        key="sofc"
                    />
                    <selected-cogen-table 
                        v-if="isSofcSelected" 
                        :selected-data="getSelectedSofc"
                    />
                    <information-box
                        title="コージェネレーション機器を指定する場合"
                        class="hundred_percent"
                    >
                        <p>メーカ名・品番等については、
                        <a
                            href="https://shoenekikiportal.hyoukakyoukai.or.jp/#/cogenerations"
                            target="_blank"
                            class="target_blank"
                        >
                            こちら
                        </a>
                        の機器の登録情報を確認します。</p>
                    </information-box>
                    <information-box
                        title="コージェネレーションの種類が「PEFC」で、かつPUの発電方式が「熱主」の場合"
                        class="hundred_percent"
                    >
                        <p>計算実行後に一次エネルギー消費量の結果を確認し、設計一次において項目別の計算値を足し合わせた値と合計欄に表示される値との差が10 MJ以上の場合は、追加の対応が必要となります。詳細については
                            <a
                                href="https://house.lowenergy.jp/dictionary/cogene#cogen_netsushu"
                                target="_blank"
                                class="target_blank"
                            >
                                こちら
                            </a>を確認します。
                        </p>
                    </information-box>    
                </app-box>
            </div>
            <!-- PEFC・SOFCに2015年度以前の評価方法またはGECの場合 -->
            <app-box
                v-if="cogen_package_input == 2 && cogen_type == 4"
                :available="true"
                label="コージェネレーションの区分"
                class="flex_column"
                name="cogen_houshiki"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2','3','4','5','6','11','7','8','9','10']"
                    v-model="cogen_houshiki"
                    :value="value"
                    unit=""
                    :key="'cogen_houshiki' + value"
                >
                    {{master.cogen_houshiki[value]}}
                </app-radio>
            </app-box>
        </app-section>
        
        <app-section v-if="cogen_package_input == '3'">
            <h3 slot="h3">
                <parts-arrow category="コージェネ">3</parts-arrow>
                <span><parts-arrow class="line">1</parts-arrow>で「品番を指定しない（パラメータを入力する）」を選択した場合、コージェネレーションのパラメータを入力して下さい。</span>
            </h3>
                <!-- PUの発電量推定時の仮想発電量 -->
                <app-box
                    :available="true"
                    label="PUの発電量推定時の仮想発電量" 
                    class="flex_column param"
                >   
                    <app-text
                        label="係数a_PU"
                        unit=""
                        v-model="cogen_pu_kasou_pgen_coef_a_PU"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="係数a_DHW"
                        unit=""
                        v-model="cogen_pu_kasou_pgen_coef_a_DHW"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="係数a_HWH"
                        unit=""
                        v-model="cogen_pu_kasou_pgen_coef_a_HWH"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                   <app-text
                        label="係数b"
                        unit=""
                        v-model="cogen_pu_kasou_pgen_coef_b"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="係数c"
                        unit=""
                        v-model="cogen_pu_kasou_pgen_coef_c"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                </app-box>
                <!-- PUの排熱量推定時の仮想燃料消費量 -->
                <app-box
                    v-if="(cogen_type == '1'||cogen_type == '4')"
                    :available="true"
                    label="PUの排熱量推定時の仮想燃料消費量" 
                    class="flex_column  param"
                >
                    <app-text
                        label="係数a_DHW"
                        unit=""
                        v-model="cogen_pu_kasou_fcost_coef_a_DHW"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="係数a_HWH"
                        unit=""
                        v-model="cogen_pu_kasou_fcost_coef_a_HWH"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                </app-box>
                <!-- PUの排熱量推定時の仮想燃料消費量 -->
                <app-box
                    v-if="(cogen_type == '1'||cogen_type == '4')"
                    :available="true"
                    label="PUの排熱量推定時の仮想排熱量上限比" 
                    class="flex_column  param"
                >
                    <app-text
                        label="係数a_DHW"
                        unit=""
                        v-model="cogen_pu_kasou_fmax_coef_a_DHW"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="係数a_HWH"
                        unit=""
                        v-model="cogen_pu_kasou_fmax_coef_a_HWH"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="係数b"
                        unit=""
                        v-model="cogen_pu_kasou_fmax_coef_b"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                </app-box>
                <!-- PUの日平均発電効率 -->
                <app-box
                    :available="true"
                    label="PUの日平均発電効率" 
                    class="flex_column param"
                >
                    <app-text
                        label="係数a_PU"
                        unit=""
                        v-model="cogen_pu_pgen_koritsu_coef_a_PU"
                        :step="0.000001"
                        class="number"
                        subscript="(小数点以下6桁)"
                    />
                    <app-text
                        label="係数a_DHW"
                        unit=""
                        v-model="cogen_pu_pgen_koritsu_coef_a_DHW"
                        :step="0.000001"
                        class="number"
                        subscript="(小数点以下6桁)"
                    />
                    <app-text
                        label="係数a_HWH"
                        unit=""
                        v-model="cogen_pu_pgen_koritsu_coef_a_HWH"
                        :step="0.000001"
                        class="number"
                        subscript="(小数点以下6桁)"
                    />
                    <app-text
                        label="係数b"
                        unit=""
                        v-model="cogen_pu_pgen_koritsu_coef_b"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="上限値"
                        unit=""
                        v-model="cogen_pu_pgen_koritsu_upper_limit"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="下限値"
                        unit=""
                        v-model="cogen_pu_pgen_koritsu_lower_limit"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                </app-box>
                <!-- PUの日平均排熱効率 -->
                <app-box
                    :available="true"
                    label="PUの日平均排熱効率" 
                    class="flex_column param"
                >
                    <app-text
                        label="係数a_PU"
                        unit=""
                        v-model="cogen_pu_hainetsu_kouritsu_coef_a_PU"
                        :step="0.000001"
                        class="number"
                        subscript="(小数点以下6桁)"
                    />
                    <app-text
                        label="係数a_DHW"
                        unit=""
                        v-model="cogen_pu_hainetsu_kouritsu_coef_a_DHW"
                        :step="0.000001"
                        class="number"
                        subscript="(小数点以下6桁)"
                    />
                    <app-text
                        label="係数a_HWH"
                        unit=""
                        v-model="cogen_pu_hainetsu_kouritsu_coef_a_HWH"
                        :step="0.000001"
                        class="number"
                        subscript="(小数点以下6桁)"
                    />
                    <app-text
                        label="係数b"
                        unit=""
                        v-model="cogen_pu_hainetsu_kouritsu_coef_b"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="上限値"
                        unit=""
                        v-model="cogen_pu_hainetsu_kouritsu_upper_limit"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                    <app-text
                        label="下限値"
                        unit=""
                        v-model="cogen_pu_hainetsu_kouritsu_lower_limit"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                </app-box>
                <!-- バックアップボイラーの種類 -->
                <app-box
                    :available="true"
                    label="バックアップボイラーの種類" 
                    class="flex_column"
                >
                    <app-radio
                        v-for="(name, value) in master.cogen_bb_type"
                        v-model="cogen_bb_type"
                        :value="value"
                        unit=""
                        :key="'cogen_bb_type' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <!-- 温水暖房への排熱利用 -->
                <app-box
                    :available="true"
                    label="温水暖房への排熱利用" 
                    class="flex_column"
                >
                    <app-radio
                        v-for="(name, value) in master.cogen_hainetsu_use"
                        v-model="cogen_hainetsu_use"
                        :value="value"
                        unit=""
                        :key="'cogen_hainetsu_use' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <!-- 排熱利用方式 -->
                <app-box
                    label="排熱利用方式"
                    :available="true"
                    v-if="cogen_hainetsu_use == '2'"
                >
                    <app-radio
                        v-for="(name, value) in master.cogen_hainetsu_use_type"
                        v-model="cogen_hainetsu_use_type"
                        :value="value"
                        unit=""
                        :key="'cogen_hainetsu_use_type' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <!-- PUの排熱利用率 -->
                <app-box
                    :available="true"
                    label="PUの給湯排熱利用率" 
                    class="flex_column param"
                >
                    <app-text
                        label=" "
                        unit=""
                        v-model="cogen_pu_hw_hainetu_use"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                </app-box>
                <app-box
                    v-if="cogen_hainetsu_use == '2'"
                    :available="true"
                    label="PUの温水暖房排熱利用率" 
                    class="flex_column param"
                >
                    <app-text
                        label=" "
                        unit=""
                        v-model="cogen_pu_hs_hainetu_use"
                        :step="0.0001"
                        class="number"
                        subscript="(小数点以下4桁)"
                    />
                </app-box>
                <!-- TUの補機消費電力 -->
                <app-box
                    :available="true"
                    label="TUの補機消費電力" 
                    class="flex_column param"
                >
                    <app-text
                        label="給湯"
                        unit="W"
                        v-model="cogen_tu_hw_sub_pcost"
                        :step="0.1"
                        class="number"
                        subscript="(小数点以下1桁)"
                    />
                    <app-text
                        v-if="cogen_hainetsu_use == '2'"
                        label="温水暖房"
                        unit="W"
                        v-model="cogen_tu_hs_sub_pcost"
                        :step="0.1"
                        class="number"
                        subscript="(小数点以下1桁)"
                    />
                </app-box>
                <!-- 定格発電出力 -->
                <app-box
                    :available="true"
                    label="定格発電出力" 
                    class="flex_column param"
                >
                    <app-text
                        label=" "
                        unit="W"
                        v-model="cogen_rated_pgen"
                        :step="1"
                        class="number"
                        subscript="(整数)"
                    />
                </app-box>
                <!-- 逆潮流 -->
                <app-box
                    :available="true"
                    label="逆潮流" 
                    class="flex_column"
                >
                    <app-radio
                        v-for="(name, value) in master.cogen_reverse_type"
                        v-model="cogen_reverse_type"
                        :value="value"
                        unit=""
                        :key="'cogen_reverse_type' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
        </app-section>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版コージェネレーション情報入力画面
 * 
 * [算出プロパティ]
 * cogenPefcFilter ... PEFCの検索ワード
 * cogenSofcFilter ... SOFCの検索ワード
 * getSelectedPefc ... 選択されているPEFC機器
 * getSelectedSofc ... 選択されているSOFC機器
 * 他は詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 * PEFC検索時 ... PEFC検索である情報を受け渡しつつ検索実行、検索結果モーダルを表示
 * SOFC検索時 ... SOFC検索である情報を受け渡しつつ検索実行、検索結果モーダルを表示
 * 
 * [データ]
 * searchPefcText ... PEFC検索のテキストボックスに入力された値
 * searchSofcText ... SOFC検索のテキストボックスに入力された値
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import device from '@/mixins/device'
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageCogeneration",
    computed: {
        ...mapGetters({
            data:'data/getData',
            /**
             * 選択されているPEFC機器
             */
            getSelectedPefc:'search/getSelectedPefc',
            /**
             * 選択されているSOFC機器
             */
            getSelectedSofc:'search/getSelectedSofc'
        }),
        ...mapComputedProperties([
            'use_cogen',
            'cogen_type',
            'cogen_package_input',
            'cogen_reverse',
            'cogen_houshiki',
            'cogen_type_param',
            'cogen_pu_kasou_pgen_coef_a_PU',
            'cogen_pu_kasou_pgen_coef_a_DHW',
            'cogen_pu_kasou_pgen_coef_a_HWH',
            'cogen_pu_kasou_pgen_coef_b',
            'cogen_pu_kasou_pgen_coef_c',
            'cogen_pu_kasou_fcost_coef_a_DHW',
            'cogen_pu_kasou_fcost_coef_a_HWH',
            'cogen_pu_kasou_fmax_coef_a_DHW',
            'cogen_pu_kasou_fmax_coef_a_HWH',
            'cogen_pu_kasou_fmax_coef_b',
            'cogen_pu_pgen_koritsu_coef_a_PU',
            'cogen_pu_pgen_koritsu_coef_a_DHW',
            'cogen_pu_pgen_koritsu_coef_a_HWH',
            'cogen_pu_pgen_koritsu_coef_b',
            'cogen_pu_pgen_koritsu_upper_limit',
            'cogen_pu_pgen_koritsu_lower_limit',
            'cogen_pu_hainetsu_kouritsu_coef_a_PU',
            'cogen_pu_hainetsu_kouritsu_coef_a_DHW',
            'cogen_pu_hainetsu_kouritsu_coef_a_HWH',
            'cogen_pu_hainetsu_kouritsu_coef_b',
            'cogen_pu_hainetsu_kouritsu_upper_limit',
            'cogen_pu_hainetsu_kouritsu_lower_limit',
            'cogen_bb_type',
            'cogen_hainetsu_use',
            'cogen_hainetsu_use_type',
            'cogen_pu_hw_hainetu_use',
            'cogen_pu_hs_hainetu_use',
            'cogen_tu_hw_sub_pcost',
            'cogen_tu_hs_sub_pcost',
            'cogen_rated_pgen',
            'cogen_reverse_type',
            'cogen_pefc_package_filter',
            'cogen_sofc_package_filter',
        ]),
        isPefcSelected(){
            return this.getSelectedPefc.value != undefined && this.cogen_type == 1
        },
        isSofcSelected(){
            return this.getSelectedSofc.value != undefined && this.cogen_type == 2
        },
    },
    mixins:[help, master, device],
    data(){
        return {
            /**
             * PEFC検索のテキストボックスに入力された値
             */
            searchPefcText: '',
            /**
             * SOFC検索のテキストボックスに入力された値
             */
            searchSofcText: '',
        }
    },
    watch:{
        /* 「コージェネレーションの種類」で「PEFC・SOFCに2015年度以前の評価方法、またはGEC」を選択しているときに、「コージェネレーション機器の指定」で「品番を指定する」を選択すると、「コージェネレーションの種類」をPEFCにする。 */
        cogen_package_input(newValue){
            if(this.cogen_type=='4' && (newValue == '1' || newValue == '3')){
                this.cogen_type = '1'
            }
        }
    },
    methods:{
        ...mapActions({
            update:'data/update',
            setResult:'search/setResult',
            searchResultShow:'view/searchResultShow'
        }),
        /**
         * PEFC検索である情報を受け渡しつつ検索実行、検索結果モーダルを表示
         */
        searchPefcCogenItem: async function(){
            this.searchCogenItem(this.cogen_pefc_package_filter, 'PEFC')
        },
        /**
         * SOFC検索である情報を受け渡しつつ検索実行、検索結果モーダルを表示
         */
        searchSofcCogenItem: async function(){
            this.searchCogenItem(this.cogen_sofc_package_filter, 'SOFC')
        },
        /**
         * コジェネ検索の共通処理
         */
        searchCogenItem: async function(searchText, type){
            const data = await this.searchCogen(type, searchText)
            this.setResult({value:searchText, result:data, type:type})
            this.searchResultShow()
        },
    }
}
</script>

<style scoped>
.param >>> .grid_2 label{
    display: inline-block;
    width: 7em;
}
.wrapper >>> .information a.target_blank.alink_disabled{
  pointer-events: none;
  color: #aaa;
}
</style>